import type { UserProfileTab } from '@/views/user/user/components/profile/types'
import eventBus from '@/utils/eventBus'

export interface GlobalUserProfilePayload {
  userId: number
  tab?: UserProfileTab
}

export interface GlobalUserChatPayload {
  userId: number
  conversationId?: string
  targetUserId?: number
}

const OPEN_USER_PROFILE_EVENT = 'global-user-profile-open'
const OPEN_USER_CHAT_EVENT = 'global-user-chat-open'
const USER_PROFILE_UPDATED_EVENT = 'global-user-profile-updated'

/**
 * 统一打开用户详情与聊天记录，业务页面无需跳转到用户列表页。
 */
export function useGlobalUserProfile() {
  function openUserProfile(userId: number, tab: UserProfileTab = 'overview') {
    if (userId <= 0) {
      return
    }
    eventBus.emit(OPEN_USER_PROFILE_EVENT, { userId, tab } satisfies GlobalUserProfilePayload)
  }

  function openUserChat(payload: GlobalUserChatPayload) {
    if (payload.userId <= 0) {
      return
    }
    eventBus.emit(OPEN_USER_CHAT_EVENT, payload)
  }

  function notifyUserProfileUpdated(userId: number) {
    eventBus.emit(USER_PROFILE_UPDATED_EVENT, userId)
  }

  function onUserProfileUpdated(handler: (userId: number) => void) {
    eventBus.on(USER_PROFILE_UPDATED_EVENT, handler)
    return () => eventBus.off(USER_PROFILE_UPDATED_EVENT, handler)
  }

  return {
    openUserProfile,
    openUserChat,
    notifyUserProfileUpdated,
    onUserProfileUpdated,
  }
}

export {
  OPEN_USER_CHAT_EVENT,
  OPEN_USER_PROFILE_EVENT,
}
